import {
  StaticQrCodeRequest,
  StaticQrCodeResponse
} from '../interfaces/static-qr-code.interface';

export const StaticQrCodeParams: StaticQrCodeRequest = {
  url: 'https://www.delta.com/us/en/delta-digital/mobile?pairingKey=01K6YLCDEGKCJIVZTX',
  background_color: '#ffffff',
  color: '#000000',
  data_pattern_shape: 'square',
  image_type: 'png',
  logo_image_url:
    'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png'
};

export const StaticQrCodeExpectedResponse: StaticQrCodeResponse = {
  url: 'https://gateway.flowcode.com/v3/codes/generator/static?url=https://www.delta.com/us/en/delta-digital/mobile?pairingKey=01K6YLCDEGKCJIVZTX&background_color=%23ffffff&color=%23000000&data_pattern_shape=square&image_type=png&logo_image_url=https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png'
};
